import { SidebarProvider } from '@/components/ui/sidebar'
import type { PropsWithChildren } from 'react'
type LayoutBaseProps = Record<never, never>

export function LayoutBase({ children }: PropsWithChildren<LayoutBaseProps>) {
  return (
    <>
      <div className="[--header-height:calc(--spacing(14))]">
        <SidebarProvider>
          <div className="flex flex-1">{children}</div>
        </SidebarProvider>
      </div>
    </>
  )
}
